"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _Text = require("./Text.style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const variantElementMap = {
  oversize: 'h1',
  body: 'span',
  bodyBold: 'span',
  heading1: 'h1',
  heading2: 'h2',
  heading3: 'h3',
  metaBold: 'span',
  meta: 'span',
  small: 'span'
};
/**
 * The Text component is used to present text content with specific,
 * design-defined typographic styles and scales.
 *
 * By default, it will render as an inline `<span>` element, though this can
 * be overridden by providing a valid elementType via the `as` prop.
 *
 * Text accepts a `variant` prop, which may be used as a shorthand for
 * rendering text with commonly used combined sets of styles (eg. font-sizes,
 * weights, families, text-transforms, etc) for different text scales (eg.
 * for various heading levels or body copy types).
 *
 * When a `variant` prop recieves a 'heading' variant (eg. h1-6), the `as` prop
 * will be automatically set to the corresponding heading tag, unless an `as`
 * prop is already provided.
 */

const Text = /*#__PURE__*/React.forwardRef(({
  align,
  as,
  color,
  family,
  lineHeight,
  size,
  transform,
  truncate,
  variant = 'body',
  weight,
  ...otherProps
}, ref) => {
  const Component = as || variantElementMap[variant] || 'span';
  return (0, _pragma.createFelaElement)(Component, _extends({
    css: _Text.css,
    cssProps: {
      align,
      color,
      family,
      lineHeight,
      size,
      transform,
      truncate,
      variant,
      weight
    },
    ref: ref
  }, otherProps));
});
Text.displayName = 'Text';
var _default = Text;
exports.default = _default;
//# sourceMappingURL=Text.js.map